export class Daterange {
    value: string;
    model: string;
    sign: string;
    inValid: boolean;
}


// WEBPACK FOOTER //
// ./src/app/modules/el-data-management/eldm-filters/entities/Daterange.model.ts